import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Guards all nested admin routes — staff JWT with dashboard access only.
 */
export function RequireStaff() {
  const { isLoading, canAccessStaffDashboard } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="border-primary h-8 w-8 animate-spin rounded-full border-b-2" />
      </div>
    );
  }

  if (!canAccessStaffDashboard) {
    return (
      <Navigate to="/staff-login" replace state={{ from: location.pathname }} />
    );
  }

  return <Outlet />;
}
